import React from "react";
import PropTypes from "prop-types";
import Linkify from 'linkify-react';

const Message = ({name, content, timestamp, direction}) => (
  <div className={`message ${direction}`}>
    <div className="user">
      {name} - {moment(timestamp).format('M/D/YYYY @ h:mma')}
    </div>
    <div className="content">
      <Linkify>
        <pre>{content}</pre>
      </Linkify>
    </div>
  </div>
);

const Messages = ({messages}) => (
  <div className="messages-box" id="messagesBox">
    {messages.length >= 50 &&
      <div className="text-center pink-text">NOTE: only the last 50 messages are displayed, if you would like access to older messages please contact support.</div>
    }
    {messages.map((message) => (
      <Message
        key={message.id}
        content={message.content}
        name={message.user.full_name}
        direction={message.direction}
        timestamp={message.created_at}
      />
    ))}
  </div>
);

Messages.defaultProps = {
  messages: PropTypes.array
};

export default Messages;
